import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "widget-header" }
const _hoisted_2 = { class: "widget-header__title" }
const _hoisted_3 = {
  key: 0,
  class: "widget-header__control"
}




export default /*@__PURE__*/_defineComponent({
  __name: 'VWidgetHeader',
  props: {
    title: { type: String, default: '' },
},
  setup(__props) {

// Other
const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString(props.title), 1),
    (_ctx.$slots.control)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "control")
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})